export default "__VITE_ASSET__NUsDifSE__"